var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inscan-shortage-shipment"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Inscan Shortage Status")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "ShipmentShortageToInscan",
      "id": "ShipmentShortageToInscan",
      "value": "ShipmentShortageToInscan"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "ShipmentShortageToInscan")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "ShipmentShortageToInscan"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "ShipmentShortageToInscan"
    }
  }, [_vm._v("Shipment Shortage To Inscan")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "BagShortageToInscan",
      "id": "BagShortageToInscan",
      "value": "BagShortageToInscan"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "BagShortageToInscan")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "BagShortageToInscan"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "BagShortageToInscan"
    }
  }, [_vm._v("Bag Shortage To Inscan")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), (_vm.checkedType == 'ShipmentShortageToInscan') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentID),
      expression: "shipmentID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipment ID",
      "name": "ShipmentID",
      "id": "ShipmentID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shipmentID)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "keyup": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentID = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ShipmentIDError))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.checkedType == 'BagShortageToInscan') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNo),
      expression: "bagNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag No",
      "name": "BagNo",
      "id": "BagNo"
    },
    domProps: {
      "value": (_vm.bagNo)
    },
    on: {
      "keyup": _vm.clearBagError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNo = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.BagNoError))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "29px"
    }
  }, [(_vm.checkedType == 'ShipmentShortageToInscan') ? _c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": _vm.getShoratgeShipmentList
    }
  }, [_vm._v("Show Items")]) : _vm._e(), _vm._v(" \n                    "), (_vm.checkedType == 'BagShortageToInscan') ? _c('button', {
    staticClass: "common-success-btn-btn",
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": _vm.markBag
    }
  }, [_vm._v("Change Bag Status To Inscan")]) : _vm._e(), _vm._v(" \n                    "), (_vm.checkedType == 'ShipmentShortageToInscan') ? _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.clearShipmentForm
    }
  }, [_vm._v("Clear")]) : _vm._e(), _vm._v(" "), (_vm.checkedType == 'BagShortageToInscan') ? _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.clearBagForm
    }
  }, [_vm._v("Clear")]) : _vm._e()])]), _vm._v(" "), (_vm.checkedType == 'ShipmentShortageToInscan') ? _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0.25rem !important"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [(_vm.IsShipmentTable) ? _c('tr', [_c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('span', [_c('b', [_vm._v("Shipment Status ")]), _vm._v(": " + _vm._s(_vm.ShoratgeShipmentList.shipmentstatus) + " ")])]), _c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_c('span', [_c('b', [_vm._v("Status ")]), _vm._v(": " + _vm._s(_vm.ShoratgeShipmentList.status) + " ")])]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.markShipment
    }
  }, [_vm._v("Change Status To Inscan")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.EmptyList) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()])])]) : _vm._e()])])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94aac01a","hasScoped":true}!./src/views/components/InscanOverageShortage/InscanShortageShipment/InscanShortageShipment.html
// module id = 1081
// module chunks = 2